<template>
  <div class="device-error-page" v-if="deviceErrorShow">
    <div class="device-error-dialog">
      <div class="device-error-marker"></div>
      <div class="close-btn" @click="hideDeviceError"></div>
      <div class="device-msg-panel">
        <div class="title">Permission acquisition failed</div>
        <div class="msg">Please check whether you have enabled the camera, microphone, and other permissions, and try to clear the cache</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "deviceerrordialog",
  props:{
    deviceErrorShow:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    hideDeviceError(){
      this.$emit('hidedeviceerror')
    },
    downApp(){
      window.open("https://chutney.onelink.me/gO7z/4029f9f5", '_blank')

    }
  }
}
</script>

<style scoped lang="less">
@import "~styles/index.less";
@import "~styles/variable.less";

.device-error-page{
  position: fixed;
  z-index: 1000;
  top:0;
  left:0;
  bottom:0;
  right:0;
  background-color: rgba(0, 0, 0, .82);

  .device-error-dialog{
    .w(650);
    .h(662);
    left: 50%;
    top: 50%;
    position: fixed;
    transform: translate(-50%,-50%);

    .device-error-marker{
      .w(378);
      .h(255);
      .ml(136);
      background: url(../../../assets/imgs/device-error-marker.png) no-repeat;
      background-size: contain;
      position: absolute;
    }

    .close-btn{
      .w(48);
      .h(48);
      background: url(../../../assets/imgs/page-close-btn.png) no-repeat;
      background-size: contain;
      position: absolute;
      .mt(161);
      .ml(564);
      z-index: 3;
      cursor: pointer;
    }

    .device-msg-panel {
      .w(650);
      .h(408);
      background: #fff;
      .b-radius(24,24,24,24);
      font-family: Gilroy-Medium;
      text-align: center;
      .mt(129);

      .title{
        .w(650);
        text-align: center;
        color: #333;
        .fs(36);
        position: absolute;
        .mt(154);

      }
      .msg{
        left: 50%;
        transform: translateX(-50%);
        .w(590);
        text-align: center;
        color: #9AA3AF;
        .fs(28);
        position: absolute;
        .mt(227);

      }
    }

    .device-action-panel {
      .w(650);
      .h(110);
      background: #FF0E74;
      .b-radius(0,0,24,24);
      font-family: Gilroy-Medium;
      text-align: center;
      text-align: center;
      font-family: Gilroy-Bold;
      color: #fff;
      .lh(110);
      .fs(32);
      cursor: pointer;

    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/svc/call/deviceerrordialog.vue